/**
 All the routes for the PorterIQ Dashboard React are added here,
 You can add a new route, customize the routes and delete the routes here.

 Once you add a new route on this file it will be visible automatically on the Sidenav.

 For adding a new route you can follow the existing routes in the routes array.
 1. The `type` key with the `collapse` value is used for a route.
 2. The `type` key with the `title` value is used for a title inside the Sidenav.
 3. The `type` key with the `divider` value is used for a divider between Sidenav items.
 4. The `name` key is used for the name of the route on the Sidenav.
 5. The `key` key is used for the key of the route (It will help you with the key prop inside a loop).
 6. The `icon` key is used for the icon of the route on the Sidenav, you have to add a node.
 7. The `collapse` key is used for making a collapsible item on the Sidenav that has other routes
 inside (nested routes), you need to pass the nested routes inside an array as a value for the `collapse` key.
 8. The `route` key is used to store the route location which is used for the React router.
 9. The `href` key is used to store the external links' location.
 10. The `title` key is only for the item with the type of `title` and it's used for the title text on the Sidenav.
 11. The `component` key is used to store the component of its route.
 */

// PorterIQ Dashboard React layouts
import SignIn from "layouts/authentication/sign-in";
import Logout from "layouts/authentication/logout";
import MarketOverview from "pages/content-strategy";
import { Redirect } from "react-router-dom";

// PorterIQ Dashboard React icons
import {
  IoShield,
  IoNewspaperOutline,
  IoMegaphoneOutline,
  IoCreateOutline,
  IoPodiumOutline,
  IoFunnelOutline,
  IoPerson,
  IoGitNetworkOutline,
  IoTrendingUpOutline,
} from "react-icons/io5";
import { IoIosLogOut } from "react-icons/io";
import { BsGraphUp, BsLightbulbFill } from "react-icons/bs";
import DigitalPresenceV2 from "pages/digital-presence-v2";
import PressDigestV2 from "pages/press-digest-v2";
import ProductInsightsPage from "pages/product-trends";
import ExpansionTrends from "pages/expansion-trends";
import AIReportsPage from "pages/competitor-reports";
import ProductComparisonPage from "pages/product-showdown";
import RDLandscapePage from "pages/rd-landscape";
import PricingAnalyticsPage from "pages/pricing-analytics";

import AdminPage from "./layouts/admin";
import KolInsightsPage from "pages/kol-insights";
import { VscTools } from "react-icons/vsc";
import Profile from "./layouts/profile";
import ForgotPassword from "./layouts/authentication/components/ForgotPassword";
import ResetPassword from "./layouts/authentication/components/ResetPassword";

// Export a function instead of a constant
const getRoutes = () => {
  return [
    {
      // M005/S04 cutover: redirect old URL → new v2 page (covers bookmarks)
      type: "collapse",
      name: "Press Digest",
      key: "press-digest",
      route: "/press-digest",
      component: () => <Redirect to="/v2/press-digest" />,
      noCollapse: true,
      hidden: true,
      secure: true,
    },
    {
      type: "collapse",
      name: "Press Digest",
      key: "press-digest-v2",
      route: "/v2/press-digest",
      icon: <IoNewspaperOutline size="15px" color="inherit" />,
      component: PressDigestV2,
      noCollapse: true,
      secure: true,
    },
    {
      // M005/S04 cutover: redirect old URL → new v2 page (covers bookmarks)
      type: "collapse",
      name: "Digital Presence",
      key: "digital-presence",
      route: "/competitor-insights/:platform",
      component: () => <Redirect to="/v2/competitor-insights/linkedin" />,
      hidden: true,
      noCollapse: true,
      secure: true,
    },
    {
      // M005/S04 cutover: redirect old URL → new v2 page (covers bookmarks)
      type: "collapse",
      name: "Digital Presence",
      key: "digital-presence",
      route: "/competitor-insights/linkedin",
      component: () => <Redirect to="/v2/competitor-insights/linkedin" />,
      hidden: true,
      noCollapse: true,
      secure: true,
    },
    {
      type: "collapse",
      name: "LinkedIn Watch",
      key: "digital-presence-v2",
      route: "/v2/competitor-insights/linkedin",
      icon: <IoFunnelOutline size="15px" color="inherit" />,
      component: DigitalPresenceV2,
      noCollapse: true,
      secure: true,
    },
    {
      // React Router match pattern for /v2/competitor-insights/:platform — hidden from nav
      type: "collapse",
      name: "LinkedIn Watch",
      key: "digital-presence-v2",
      route: "/v2/competitor-insights/:platform",
      component: DigitalPresenceV2,
      hidden: true,
      noCollapse: true,
      secure: true,
    },
    {
      type: "collapse",
      name: "KOL Insights",
      key: "kol-insights",
      route: "/kol-insights",
      icon: <IoGitNetworkOutline size="15px" color="inherit" />,
      component: KolInsightsPage,
      noCollapse: true,
      locked: false,
      secure: true,
    },
    {
      type: "collapse",
      name: "Content Strategy",
      key: "content-strategy",
      route: "/content-strategy",
      icon: <IoCreateOutline size="15px" color="inherit" />,
      component: MarketOverview,
      noCollapse: true,
      locked: false,
      secure: true,
    },
    {
      type: "collapse",
      name: "Product Trends",
      key: "product-trends",
      route: "/product-trends",
      icon: <IoMegaphoneOutline size="15px" color="inherit" />,
      component: ProductInsightsPage,
      noCollapse: true,
      locked: false,
      secure: true,
    },
    {
      type: "collapse",
      name: "Expansion Trends",
      key: "expansion-trends",
      route: "/expansion-trends",
      icon: <IoTrendingUpOutline size="15px" color="inherit" />,
      component: ExpansionTrends,
      noCollapse: true,
      locked: false,
      secure: true,
    },
    {
      type: "collapse",
      name: "Product Showdown",
      key: "product-showdown",
      route: "/product-showdown",
      icon: <IoShield size="15px" color="inherit" />,
      component: ProductComparisonPage,
      noCollapse: true,
      locked: false,
      secure: true,
    },
    {
      type: "collapse",
      name: "R&D Landscape",
      key: "rd-landscape",
      route: "/rd-landscape",
      icon: <BsLightbulbFill size="15px" color="inherit" />,
      component: RDLandscapePage,
      noCollapse: true,
      locked: false,
      secure: true,
    },
    {
      type: "collapse",
      name: "Competitor Reports",
      key: "competitor-reports",
      route: "/competitor-reports",
      icon: <IoPodiumOutline size="15px" color="inherit" />,
      component: AIReportsPage,
      noCollapse: true,
      locked: false,
      secure: true,
    },
    {
      type: "collapse",
      name: "Pricing Analytics",
      key: "pricing-analytics",
      route: "/pricing-analytics",
      icon: <BsGraphUp size="15px" color="inherit" />,
      component: PricingAnalyticsPage,
      noCollapse: true,
      locked: false,
      secure: true,
      adminOnly: true,
      requiredRole: "ADMIN",
    },
    {
      type: "collapse",
      name: "Sign In",
      key: "sign-in",
      route: "/authentication/sign-in",
      icon: <IoIosLogOut size="15px" color="inherit" />,
      component: SignIn,
      noCollapse: true,
      hidden: true,
      secure: false,
    },
    {
      type: "collapse",
      name: "Admin Panel",
      key: "admin-panel",
      route: "/admin",
      icon: <VscTools size="15px" color="inherit" />,
      component: AdminPage,
      noCollapse: true,
      secure: true,
      adminOnly: true,
    },
    { type: "divider", key: "divider-1" },
    {
      type: "collapse",
      name: "Logout",
      key: "logout",
      route: "/authentication/logout",
      icon: <IoIosLogOut size="15px" color="inherit" />,
      component: Logout,
      noCollapse: true,
      locked: false,
      secure: false,
    },
    {
      type: "collapse",
      name: "Profile",
      key: "profile",
      route: "/profile",
      icon: <IoPerson size="15px" color="inherit" />,
      component: Profile,
      noCollapse: true,
      secure: true,
    },
    {
      type: "collapse",
      name: "Forgot Password",
      key: "forgot-password",
      route: "/authentication/forgot-password",
      component: ForgotPassword,
      noCollapse: true,
      hidden: true,
      secure: false,
    },
    {
      type: "collapse",
      name: "Reset Password",
      key: "reset-password",
      route: "/authentication/reset-password",
      component: ResetPassword,
      noCollapse: true,
      hidden: true,
      secure: false,
    },
  ];
};

export default getRoutes;